import EventEmitter from 'eventemitter3';
import StatusTextEvents from '../events/StatusTextEvents';
import { Text, Tween } from '../utils/utils';

export default class StatusText {
  // ================================================================================================
  // properties
  // ================================================================================================
  private static readonly DEFAULT_WAIT_DURATION_MS = 3000;

  private static readonly DEFAULT_TWEEN_DURATION_MS = 750;

  private textObject: Text;

  private tween: Tween;

  private _events = new EventEmitter();

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(textObject: Text) {
    this._events = new EventEmitter();
    this.textObject = textObject;
    this.clear();
  }

  // ----------------------------------------------------------------------------------------------
  clear(): void {
    if (this.textObject) {
      this.stopTween();
      this.textObject.visible = false;
    }
  }

  // ----------------------------------------------------------------------------------------------
  set error(value: string) {
    if (this.textObject) {
      this.setText(value, '#f50');
      this.startFadeOutTween();
    }
  }

  // ----------------------------------------------------------------------------------------------
  get events(): EventEmitter {
    return (this._events);
  }

  // ----------------------------------------------------------------------------------------------
  set label(value: string) {
    if (this.textObject) {
      this.stopTween();
      this.setText(value, '#333');
    }
  }

  // ----------------------------------------------------------------------------------------------
  set progress(value: string) {
    if (this.textObject) {
      this.setText(value, '#00f');
      this.startProgressTween();
    }
  }

  // ----------------------------------------------------------------------------------------------
  set success(value: string) {
    if (this.textObject) {
      this.setText(value, '#08f');
      this.startFadeOutTween();
    }
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private setText(text: string, color: string): void {
    this.textObject.color = color;
    this.textObject.text = text;
    this.textObject.visible = true;
    this.textObject.alpha = 1.0;
  }

  // ----------------------------------------------------------------------------------------------
  private startFadeOutTween(): void {
    this.stopTween();

    this.tween = createjs.Tween.get(this.textObject).wait(StatusText.DEFAULT_WAIT_DURATION_MS).to({
      alpha: 0,
    }, StatusText.DEFAULT_TWEEN_DURATION_MS);

    this.tween.on('complete', () => {
      this._events.emit(StatusTextEvents.COMPLETE, this);
    });
  }

  // ----------------------------------------------------------------------------------------------
  private startProgressTween(): void {
    this.stopTween();

    const tweenProps: createjs.TweenProps = {
      loop: -1,
      bounce: true,
    };

    this.tween = createjs.Tween.get(this.textObject, tweenProps).to({
      alpha: 0.25,
    }, StatusText.DEFAULT_TWEEN_DURATION_MS);
  }

  // ----------------------------------------------------------------------------------------------
  private stopTween(): void {
    if (this.tween) {
      createjs.Tween.removeTweens(this.tween.target);
      this.tween = null;
    }
  }
}
